import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataWarehouseService } from '../../../core/services';
import { BehaviorSubject } from 'rxjs';
import { PageRequestModel } from '../../../core/models/PageRequestModel';

@Component({
  selector: 'brd-data-warehouse-entity-lookup-modal',
  templateUrl: './data-warehouse-entity-lookup-modal.component.html',
  styleUrls: ['./data-warehouse-entity-lookup-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataWarehouseEntityLookupModalComponent implements OnInit {
  listMetadata: any;
  parent: { entityKey: string; key: string };
  items = new BehaviorSubject<any[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  totalCount = new BehaviorSubject<number>(0);

  constructor(public dialogRef: MatDialogRef<DataWarehouseEntityLookupModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dataWarehouseService: DataWarehouseService) {
    this.listMetadata = data.metadata;
    this.parent = data.parent;
  }

  ngOnInit() {}

  onPageRequest(pageRequest: PageRequestModel) {
    this.loading.next(true);
    this.dataWarehouseService
      .getWarehouseList(
        this.listMetadata.classMetadataItems.entityKey,
        this.parent ? this.parent.entityKey : null,
        this.parent ? this.parent.key : null,
        pageRequest.page,
        pageRequest.pageSize,
        pageRequest.sort,
        pageRequest.sortDirection,
        pageRequest.searchTerm,
        this.dataWarehouseService.currentSubmittingEntityKey,
        false,
      )
      .take(1)
      .subscribe(r => {
        // TODO: handle errors
        this.loading.next(false);
        if (!r.hasError) {
          this.items.next(r.items);
          this.totalCount.next(r.totalCount);
        }
      });
  }

  onItemSelected(item: any) {
    this.dialogRef.close(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/components/data-warehouse-entity-lookup/data-warehouse-entity-lookup-modal.component.ts